import { getMapOptions } from '@/utils/index'
import { getMaterialconfig } from '@/views/insurance/jijia/material-config'
import {
  DeviceJijiaInsuranceInfo,
  DeviceJijiaInsuranceInfoProjectItem,
  ConfirmInsureParamsApplicantInfo,
  ConfirmInsureParamsInsurantInfo,
} from '@/types/insurance'

// 保险方案类型
export const JijiaInsuranceProTypeMap = new Map([
  [1, '基础版'],
  [2, '进阶版'],
])

// 保险阶段：1、首保 2、首年二保 3、续保 4、续保二保
export const JijiaInsuranceStageMap = new Map([
  [1, '首保'],
  [2, '首年二保'],
  [3, '续保'],
  [4, '续保二保'],
])

// 投保人类型， 个人与企业与后端投保保持一致，团体为前端定义，传给后端仍然以企业的值给，证件类型会不同

export const JijiaInsurancePersonalTypeMap = new Map([
  ['1', '个人'],
  ['0', '企业'],
  ['2', '团体'],
])
export const getJijiaInsurancePersonalTypeOptions = function (all = true): Array<{
  label: string
  value: string
}> {
  return getMapOptions<string>(JijiaInsurancePersonalTypeMap, all)
}

// 投保人与投保证件类型文案映射
export const JijiaInsranceCertifivateTextTypeMap = new Map([
  ['1', '身份证号'],
  ['0', '统一信用代码'],
  ['2', '工商运营执照号'],
])
// 投保时参数证件类型值映射个人
export const JijiaInsranceApplyParamsPersonalCertifivateTextTypeMap = new Map([
  ['01', '身份证'],
  ['02', '护照'],
  ['03', '军人证'],
  ['04', '港澳通行证'],
  ['05', '驾驶证'],
  ['06', '港澳回乡证或台胞证'],
  ['07', '临时身份证'],
  ['99', '其他'],
])

// 投保时参数证件类型值映射团体
export const JijiaInsranceApplyParamsCompanyCertifivateTextTypeMap = new Map([
  ['01', '组织机构代码证'],
  ['02', '税务登记证'],
  ['03', '统一社会信用代码'],
  ['04', '工商营业执照号'],
  ['99', '其他'],
])
// 是否使用权益选项
export const JijiaInsranceEquityMap = new Map([
  ['1', '9 折购保'],
  ['2', '不使用权益'],
])

export const getJijiaInsuranceEquityOptions = function (all = true): Array<{
  label: string
  value: string
}> {
  return getMapOptions<string>(JijiaInsranceEquityMap, all)
}

// 平安三责险投保人类型
export const ThirdLiabilityInsuranceMap = new Map([
  ['1', '个人'],
  ['2', '企业'],
  ['3', '团体'],
])
// 投保人与投保证件类型文案映射
export const ThirdLiabilityInsuranceTextTypeMap = new Map([
  ['1', '身份证号'],
  ['2', '统一信用代码'],
  ['3', '工商运营执照号'],
])

export const getThirdLiabilityInsuranceOptions = function (all = true): Array<{
  label: string
  value: string
}> {
  return getMapOptions<string>(ThirdLiabilityInsuranceMap, all)
}

// 是否使用ubi
export const judgeInsuranceItemUseUbi = (item: DeviceJijiaInsuranceInfo): boolean => {
  return [2, 3].includes(item?.cycle_year) && [1, 2].includes(item.insurance_type)
}
// 获取设备对应的保险物料信息
export function getInsuranceDeviceMaterialInfo(
  item: DeviceJijiaInsuranceInfoProjectItem
): string[][] {
  if (!item) {
    return []
  }
  const model = item.eq_model.toLocaleLowerCase()
  return getMaterialconfig(String(item.pro_type), model)
}
// 是否有物料信息查看
export const judgeInsuranceHasMaterialCheck = (
  item: DeviceJijiaInsuranceInfoProjectItem
): boolean => {
  return false // 产品要求默认不给查看
  if (!item) {
    return false
  }
  return getInsuranceDeviceMaterialInfo(item).length > 0
}

// 查看保障方案
export function getInsuranceNameInfo(item: DeviceJijiaInsuranceInfoProjectItem): {
  productType: string
  type: string
} {
  // 产品类型：1、基础版 2、进阶版
  const productType = JijiaInsuranceProTypeMap.get(item?.pro_type) || ''
  let type = ''
  if (item?.stage !== 1) {
    type = JijiaInsuranceStageMap.get(item?.stage)
  }
  type = type ? `(${type})` : ''
  return {
    productType,
    type,
  }
}
// 获取生效时间
export function getInusranceEffectStr(effectTime: string): string {
  if (!effectTime) {
    return ''
  }
  const effectTimeValue = new Date(effectTime).setHours(0, 0, 0, 0)
  const todayvalue = new Date().setHours(0, 0, 0, 0)
  const isTomorrow = effectTimeValue - todayvalue === 86400000
  return isTomorrow ? '次日生效' : '到期生效'
}

// 返回保障范围文案
export function getInsuranceCoverage(item: DeviceJijiaInsuranceInfoProjectItem): string {
  return item?.pro_type === 1 ? '电子件' : '电子件及结构件'
}

// 获取证件类型文案
export function getInsuranceCertificateTypeText(
  item: ConfirmInsureParamsApplicantInfo | ConfirmInsureParamsInsurantInfo
): string {
  return item.personnelType === '1'
    ? JijiaInsranceApplyParamsPersonalCertifivateTextTypeMap.get(item.certificateType)
    : JijiaInsranceApplyParamsCompanyCertifivateTextTypeMap.get(item.certificateType)
}
